import React from 'react';
import { BsLinkedin, BsGithub } from 'react-icons/bs';
import { FaAngellist } from 'react-icons/fa';
import { RiTwitterXLine } from 'react-icons/ri';


const SocialMedia = () => (
  <div className="app__social">
    <a href="https://www.linkedin.com/in/marwan-abdelsattar/" target="_blank">
    <div>
      <BsLinkedin />
    </div>
    </a>
    <a href="https://github.com/MarwanDev/" target="_blank">
    <div>
      <BsGithub />
    </div>
    </a>
    <a href="https://twitter.com/MarwanEg/" target="_blank">
    <div>
      <RiTwitterXLine />
    </div>
    </a>
    <a href="https://wellfound.com/u/marwan-abdelsattar/" target="_blank">
    <div>
      <FaAngellist />
    </div>
    </a>
  </div>
);

export default SocialMedia;
